import 'regenerator-runtime/runtime';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  VorbelegungPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, JhpVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';

export function* watchVorbelegungRequested() {
  yield takeEvery(GlobalActions.VORBELEGUNG_REQUESTED, safeSaga(vorbelegungSaga, App.JHP));
}

const globalActions = new GlobalActions();

export function* vorbelegungSaga(action: GlobalAction<VorbelegungPayload>) {
  if (action.payload.appId !== App.JHP) {
    return;
  }
  const state: IAppState = yield select();
  let beibehalten = false;
  const globalPut = GlobalPut.getInstance();
  if (!state.produkt?.produktlinien || state.produkt?.produktlinien.length === 0) {
    yield take(GlobalActions.PRODUKT_RECEIVED);
  }
  const vorbelegungDaten = action.payload?.vorhandeneVorbelegungdaten;
  if (vorbelegungDaten?.internerVertragsbezugs) {
    yield put(
      globalActions.internerVertragsbezugReceived(
        vorbelegungDaten.internerVertragsbezugs,
        App.JHP,
        state.angebotsId,
      ),
    );
  }
  if (!state.vertragsoptionen?.beibehalten) {
    yield call(
      [globalPut, globalPut.put],
      globalActions.navigationRequested({
        appId: App.JHP,
        subroute: '/eingabe',
      }),
    );
  } else {
    beibehalten = true;
    const jhpVorbelegungdaten: JhpVorbelegungdaten = action.payload
      .vorhandeneVorbelegungdaten as JhpVorbelegungdaten;
    yield call(
      [globalPut, globalPut.put],
      globalActions.vorbelegungForBeibehaltungRequested(jhpVorbelegungdaten),
    );
  }
  yield call(
    [globalPut, globalPut.put],
    globalActions.vorbelegungFinished({
      appId: App.JHP,
      vorhandeneVorbelegungdaten: null,
      beibehalten,
    }),
  );
}
